import { Component } from '@theme/component';

/**
 * Navigatie voor de maatdropdown in `blocks/product-family-size.liquid`.
 *
 * De maten zijn aparte producten uit hetzelfde "Productfamilie"-metaobject,
 * dus een keuze is een navigatie. Een `<option>` kan geen `href` dragen, en de
 * dropdown blijft bewust een native `<select>` (platte tekst, geen swatches) —
 * vandaar deze ene regel JS in plaats van een link-lijst.
 *
 * De waarde van elke optie is de product-URL uit Liquid; er wordt niets uit
 * gebruikersinvoer samengesteld.
 *
 * @typedef {object} Refs
 * @property {HTMLSelectElement} select
 *
 * @extends {Component<Refs>}
 */
class ProductFamilySize extends Component {
  requiredRefs = ['select'];

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('pageshow', this.#resetSelection);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('pageshow', this.#resetSelection);
  }

  /**
   * Na "Terug" haalt de browser de pagina uit de back/forward-cache, met de
   * select nog op de maat waar de klant naartoe navigeerde. Dan toont de
   * dropdown de verkeerde maat, en opnieuw die maat kiezen doet niets omdat
   * het al de waarde is. Terug naar de optie die Liquid als `selected`
   * markeerde (het huidige product). `autocomplete="off"` op de select dekt
   * de browsers die de formulierwaarde zonder bfcache herstellen.
   *
   * @param {PageTransitionEvent} event
   */
  #resetSelection = (event) => {
    if (!event.persisted) return;

    const { select } = this.refs;
    const current = Array.from(select.options).find((option) => option.defaultSelected);

    if (current) select.value = current.value;
  };

  handleChange() {
    const url = this.refs.select.value;

    if (!url) return;

    window.location.href = url;
  }
}

if (!customElements.get('product-family-size-component')) {
  customElements.define('product-family-size-component', ProductFamilySize);
}
